<nav class="navbar navbar-expand-lg navbar-dark mb-4" style="z-index: 1100">
  <img class="Logo" width="40" alt="TCO Logo" src=".\assets\TCO.png" />
  <a class="navbar-brand" [routerLink]="['/TCO']">
    <b class="app-name">{{ AppName }}</b>
  </a>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active nav-item-margin">
        <a class="nav-link" mat-button [ngClass]="{ 'active-button': isMapActive() }" [routerLink]="['/TCO']">
          <b class="main-text">{{ main }}</b>
        </a>
      </li>
      <li class="nav-item dropdown nav-item-margin-small" *ngFor="let group of arr">
        <a
          mat-button
          [ngClass]="{ 'active-button': isActive(group.routeName) }"
          class="nav-link"
          id="navbarDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <b class="group-name">{{ group.name }}</b>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <div class="dropdown-row" *ngFor="let item of group.items; let i = index">
            <ul class="dropdown-list">
              <li class="dropdown-item-container">
                <a class="dropdown-item">
                  <b style="color: #0066b2;">{{ item.name }}</b>
                </a>
                <ul>
                  <li *ngFor="let child of item.childs">
                    <ng-container *ngIf="child.name === 'Schema'; else normalLink">
                      <a class="dropdown-item" [href]="getSchemaUrl()" target="_blank">
                        {{ child.name }}
                      </a>
                    </ng-container>
                    <ng-template #normalLink>
                      <a
                        class="dropdown-item"
                        [ngClass]="{ 'active-button2': isDropdownItemActive(child.route) }"
                        [routerLink]="['/TCO/ProcessEng/' + child.route]"
                      >
                        {{ child.name }}
                      </a>
                    </ng-template>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>

    <div class="languages">
      <div
        *ngFor="let lang of languages"
        class="languages__item"
        [class.active]="translate.currentLang === lang"
        (click)="selectLang(lang)"
      >
        {{ lang }}
      </div>
    </div>
  </div>
  <app-app-version></app-app-version>
</nav>
<nav
  class="navbar navbar-expand-lg navbar-dark mb-4"
  *ngIf="!isMainPage && !isNotAuthorize"
> 
  <div class="collapse navbar-collapse" id="secondNavbarSupportedContent">
    <ul class="navbar-nav mr-auto" style="justify-content: center; display: flex">
      <div style="margin-left: 10px" *ngFor="let group of filteredArr">
        <div *ngFor="let item of group.items">
          <div>
            <div style="display: flex; align-items: center">
              <b
                style="text-transform: uppercase; color: white; margin-right: 10px; margin-left: 20px; font-size: 1.2em;"
              >
                {{ item.name }} :
              </b>
              <div *ngFor="let child of item.childs" style="display: flex; list-style-type: none; padding: 0">
                <div>
                  <li class="nav-item active" style="margin-left: 10px; text-transform: uppercase; font-size: 1.1em;">
                    <ng-container *ngIf="child.name === 'Schema'; else normalLink">
                      <a class="nav-link" [href]="getSchemaUrl()" target="_blank" style="text-transform: uppercase; font-size: 1.1em" mat-button>
                        <b style="font-size: 1em; margin-left: 10px;">{{ child.name }}</b>
                      </a>
                    </ng-container>
                    <ng-template #normalLink>
                      <a
                        class="nav-link"
                        style="text-transform: uppercase; font-size: 1.1em"
                        mat-button
                        [ngClass]="{ 'active-button': isSubChildActive(child.routeName) }"
                        [routerLink]="['/TCO/ProcessEng/' + child.route]"
                      >
                        <b style="font-size: 1em; margin-left: 10px;">{{ child.name }}</b>
                      </a>
                    </ng-template>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ul>
  </div>
</nav>